import { MdSearch } from 'react-icons/md';
import { createSearchParams } from 'react-router-dom';
import { ROUTES } from '../../../constants';
import { buildRecordRoute } from '../../../utils/recordIds';
import { CommandPaletteItem } from './commandPalette.types';

export const MIN_RECORD_SEARCH_LENGTH = 2;
export const RECORD_ITEM_ID_PREFIX = 'record-';
export const ACCOUNT_FALLBACK_ITEM_ID = 'record-search-accounts';

export interface RecordSearchResult {
  id: string;
  customId?: string | null;
  status?: string | null;
  [field: string]: unknown;
}

export interface RecordFieldConfig {
  nameField: string;
  entityDisplayName: string;
}

const formatStatusLabel = (status: string): string =>
  status
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export const mapRecordsToCommandItems = (
  records: RecordSearchResult[],
  { nameField, entityDisplayName }: RecordFieldConfig,
): CommandPaletteItem[] =>
  records.map((record) => {
    const name = record[nameField];
    const label =
      (typeof name === 'string' && name) || record.customId || record.id;
    const description = [
      record.id,
      record.customId,
      record.status ? formatStatusLabel(record.status) : undefined,
    ]
      .filter(Boolean)
      .join(' · ');
    return {
      id: `${RECORD_ITEM_ID_PREFIX}${record.id}`,
      label,
      description,
      category: entityDisplayName,
      route: buildRecordRoute(record.id),
      icon: MdSearch,
    };
  });

export const buildAccountSearchFallbackItem = (
  query: string,
): CommandPaletteItem => ({
  id: ACCOUNT_FALLBACK_ITEM_ID,
  label: `Search accounts for “${query}”`,
  description: '',
  category: 'Accounts',
  route: `${ROUTES.ACCOUNT_LIST}?${createSearchParams({ search: query })}`,
  icon: MdSearch,
});
